import { Head } from '@inertiajs/react'
import DashboardLayout from '@/frontend/layouts/DashboardLayout'
import FdeShell from '@/frontend/features/Fde/FdeShell'
import InvestigationWorkspace from '@/frontend/features/Fde/investigations/InvestigationWorkspace'
import InvestigationScopeRecovery from '@/frontend/features/Fde/investigations/InvestigationScopeRecovery'
import { matchesInvestigationProject } from '@/frontend/features/Fde/investigations/format'
import type { InvestigationsPageProps } from '@/frontend/features/Fde/investigations/types'

export default function InvestigationsIndex({ fde, investigations }: InvestigationsPageProps) {
  // A different organization/project is a hard state boundary. Do not retain
  // drafts or open evidence panels from a previously authorized project.
  const scope = `${fde.organization.id}:${fde.project?.id}`
  const matches = matchesInvestigationProject(fde.project?.id, investigations.project.id)
  return <>
    <Head title={investigations.labels.title} />
    <FdeShell copy={fde.copy} eyebrow="" title={fde.project?.name ?? fde.organization.name} description="" projectId={fde.project?.id}>
      {matches ? <InvestigationWorkspace key={scope} data={investigations} /> : <InvestigationScopeRecovery projectId={fde.project?.id} copy={investigations.labels} />}
    </FdeShell>
  </>
}

InvestigationsIndex.layout = (page: React.ReactElement) => <DashboardLayout variant="fullscreen">{page}</DashboardLayout>
